module.exports = __webpack_public_path__ + "statics/img/4-3.e776e4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon/4-3.png
// module id = UDXH
// module chunks = 1